export const iconFontAwesomeLogisticsHelicopter = (
	<i className="fa-solid fa-helicopter"></i>
);
